import { request } from './createRequest';
import { CallMeBackAppointmentResponse, CallMeBackRequest } from './types';

export const createCallMeBackAppointment = (
  callMeBackRequest: CallMeBackRequest
): Promise<CallMeBackAppointmentResponse> => {
  return request
    .post(`/v2/appointments/call-me-back`, callMeBackRequest)
    .then((res) => ({ data: res.data, status: res.status }))
    .catch((reason) => ({ data: {}, status: reason.status })) as Promise<CallMeBackAppointmentResponse>;
};
